"use strict";

exports.__esModule = true;
exports.verticalAlignmentValues = exports.spacingValues = exports.horizontalAlignmentValues = exports.directions = void 0;
var _spacingSt = require("../Foundation/stylable/spacing.st.css");
var directions = exports.directions = {
  horizontal: 'horizontal',
  vertical: 'vertical'
};
var horizontalAlignmentValues = exports.horizontalAlignmentValues = {
  left: 'left',
  center: 'center',
  right: 'right',
  'space-between': 'space-between'
};
var verticalAlignmentValues = exports.verticalAlignmentValues = {
  top: 'top',
  middle: 'middle',
  bottom: 'bottom',
  'space-between': 'space-between'
};
var spacingValues = exports.spacingValues = {
  tiny: "".concat(parseInt(_spacingSt.stVars.Spacing), "px"),
  small: "".concat(parseInt(_spacingSt.stVars.Spacing) * 2, "px"),
  medium: "".concat(parseInt(_spacingSt.stVars.Spacing) * 3, "px"),
  large: "".concat(parseInt(_spacingSt.stVars.Spacing) * 4, "px")
};
//# sourceMappingURL=constants.js.map